<template>
<!--    <div id="global-loader">-->
<!--      <div class="whirly-loader"> </div>-->
<!--    </div>-->
    <!-- Main Wrapper -->
    <div class="main-wrapper">
      <!-- Header component -->
      <Header v-if="!isAuthPage" />

      <!-- Sidebar component -->
      <Sidebar v-if="!isAuthPage" />
      
      <!-- Content Section -->
      <div class="page-wrapper" v-if="!isAuthPage" >
        <div class="content">
          <router-view></router-view>
        </div> 
      </div>
      <div class="" v-else >
          <router-view></router-view> 
      </div>
      
<!--      <div class="customizer-links" id="setdata">-->
<!--        <ul class="sticky-sidebar">-->
<!--          <li class="sidebar-icons">-->
<!--            <a href="#" class="navigation-add" data-bs-toggle="tooltip" data-bs-placement="left" data-bs-original-title="Theme">-->
<!--              <i data-feather="settings" class="feather-five"></i>-->
<!--            </a>-->
<!--          </li>-->
<!--        </ul>-->
<!--		  </div>-->
    </div>
    <!-- /Main Wrapper -->
</template>
  
<script>
  import Header from "../layouts/Header.vue";
  import Sidebar from "../layouts/Sidebar.vue";
  
  export default {
    components: {
      Header,
      Sidebar,
    },
    computed: {
      isAuthPage() {
        return this.$route.path === "/login";
      },
    },
    mounted() {
      // POS ↔ main layout swap can leave the theme overlay open on a detached wrapper.
      document.documentElement.classList.remove("menu-opened");
      document.querySelectorAll(".main-wrapper.slide-nav").forEach((el) => {
        el.classList.remove("slide-nav");
      });
      document.querySelectorAll(".sidebar-overlay.opened").forEach((el) => {
        el.classList.remove("opened");
      });
    },
  };
</script>
  

  